<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import TextareaField from 'src/components/desktop/textarea-field.vue'
  export default TextareaField
</script>
